module.exports = __webpack_public_path__ + "img/Shape 1.7d3dd985.svg";